import { lazy } from "react";

const routes = [
  {
    path: "/category-location-mapping",
    element: lazy(() => import("../pages/Category/CategoryLocationMapping")),
  },
  {
    path: "/category-location-mapping/add",
    element: lazy(() =>
      import("../pages/Category/CategoryLocationMappingForm")
    ),
  },
  {
    path: "/category-location-mapping/add/:id",
    element: lazy(() =>
      import("../pages/Category/CategoryLocationMappingForm")
    ),
  },
];

export default routes;
